import { Stack } from '@chakra-ui/react';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/uikit';
import { cancelPaymentAtom } from 'data/payments/atoms';
import { trackEvent } from 'utils/analytics';
import { isFormLoading } from 'utils/atoms/dataFetchingAtom';

interface PaymentClientControlsProps {
  id: string;
  failureRedirectLink: string | null;
  onPaid: () => void;
}

export function PaymentClientControls({
  id,
  failureRedirectLink,
  onPaid,
}: PaymentClientControlsProps) {
  const { t } = useTranslation('payments');
  const [cancelFormState, cancel] = useAtom(cancelPaymentAtom);
  const cancelIsLoading = isFormLoading(cancelFormState);

  return (
    <Stack spacing='24px' direction='row' w='100%' justify='space-between'>
      {failureRedirectLink ? (
        <Button
          isLoading={cancelIsLoading}
          w='50%'
          variant='grey'
          onClick={async () => {
            await cancel({ depositId: id });
            window.location.href = failureRedirectLink;
          }}
        >
          {t('cancel_payment')}
        </Button>
      ) : null}
      <Button
        w='50%'
        variant='success'
        onClick={async () => {
          trackEvent('deposit-paid-button-pressed');
          onPaid();
        }}
      >
        {t('payment_paid')}
      </Button>
    </Stack>
  );
}
